/**
 * Der Titel der aktuellen Seite, wie ihn die Navigation kennt – damit `PageTemplate` ihn auf
 * jeder Seite in den Header bringt, ohne dass die Seite selbst etwas dafür tut.
 *
 * Gesetzt wird er dort, wo die Navigation lebt: `ProjectLayout` leitet ihn aus `PROJECT_PAGES`
 * ab, die Mandanten-Verwaltung aus ihrer Sidebar. Eine neue Seite bekommt ihn damit
 * automatisch. Ohne Provider zeigt der Header keinen Titel (Startseite, Admin-Übersicht).
 */
import { createContext, useContext } from "react";
import type { PageTitleBack } from "./SeitenTitel";

export interface SeitenTitelDaten {
  /** Rückweg eines geöffneten Datensatzes – steht über dem Titel */
  back?: PageTitleBack;
  titel: string;
}

export const SeitenTitelContext = createContext<SeitenTitelDaten | null>(null);

export const useSeitenTitel = () => useContext(SeitenTitelContext);
